module.exports = __webpack_public_path__ + "img/calendar-notifications-empty.30063059.svg";